import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c3acadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ion-text-right"
}

import { IonPage, IonContent, IonHeader, IonToolbar, IonTitle, IonListHeader, IonAccordionGroup, IonLabel, IonIcon, IonButton, onIonViewWillEnter, modalController } from '@ionic/vue'
import ScheduleItem from '@/components/ScheduleItem.vue'
import  { addCircleOutline } from 'ionicons/icons'

import { computed, ref } from 'vue'
import { useEventStore, EventScheduleItem } from '@/store/event'
import { useAuthStore } from '@/store/auth'
import { format } from '@/lib/date-fns-local'
import { App as CapApp } from '@capacitor/app'
import { sub as dateSub } from 'date-fns'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventScheduleTab',
  setup(__props) {

const openedScheduleItem = ref<string | boolean | undefined>()
const $store = useEventStore()

const days = computed<Map<string, EventScheduleItem[]>>(() => {
  const days = new Map()
  $store.schedule.slice()
    .sort((a, b) => a.time.start.valueOf() - b.time.start.valueOf())
    .forEach(item => {
      const day = item.time.start.toDateString()
      const collection = days.get(day)
      if (collection) {
        collection.push(item)
      } else {
        days.set(day, [item])
      }
    })

  return days
})

function openCurrentScheduleItem () {
  const currentTime = new Date()
  $store.schedule.forEach(item => {
    if (dateSub(item.time.start, { minutes: 5 }) < currentTime && item.__id) {
      openedScheduleItem.value = item.__id
      window.document.querySelector(`[data-id="${item.__id}"]`)?.scrollIntoView()
      return
    }
  })
}

CapApp.addListener('appStateChange', async ({ isActive }) => {
  if (isActive) {
    openCurrentScheduleItem()
  }
})

onIonViewWillEnter(openCurrentScheduleItem)

async function createScheduleItem (defaultStartTime?: Date) {
  if (!defaultStartTime && days.value.size) {
    const lastDay = Array.from(days.value.values()).pop()
    defaultStartTime = lastDay?.pop()?.time.start
  }
  const ScheduleItemForm = await import('@/components/ScheduleItemForm.vue')
  return (await modalController.create({
    component: ScheduleItemForm.default,
    componentProps: { defaultStartTime },
    ...ScheduleItemForm.modalOptions
  })).present()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonHeader), {
            class: "event-banner-header",
            mode: "ios",
            style: _normalizeStyle({ backgroundImage: `url(${_unref($store).event?.bannerUrl})` })
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonTitle), { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref($store).event?.displayName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(days), ([day, items]) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: day }, [
              _createVNode(_unref(IonListHeader), { lines: "full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(format)(new Date(day), 'EEEE')), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (_unref(useAuthStore)().claims.isAdmin)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        size: "small",
                        fill: "clear",
                        onClick: ($event: any) => (createScheduleItem(items[0].time.start))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "icon-only",
                            icon: _unref(addCircleOutline)
                          }, null, 8, ["icon"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024),
              _createVNode(_unref(IonAccordionGroup), {
                modelValue: openedScheduleItem.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((openedScheduleItem).value = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                    return (_openBlock(), _createBlock(ScheduleItem, {
                      key: item.__id,
                      item: item,
                      value: item.__id
                    }, null, 8, ["item", "value"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ], 64))
          }), 128)),
          (_unref(useAuthStore)().claims.isAdmin)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(useAuthStore)().claims.isAdmin)
                  ? (_openBlock(), _createBlock(_unref(IonButton), {
                      key: 0,
                      size: "small",
                      fill: "clear",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (createScheduleItem()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "icon-only",
                          icon: _unref(addCircleOutline)
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})